/*
 *in this module there are all the functions to create
 *  - plot the marker
 *  - manipulate the marker
 */
import VectorLayer from 'ol/layer/Vector'
import {Icon, Style} from 'ol/style'
import Draw from 'ol/interaction/Draw'
import VectorSource from 'ol/source/Vector'
import Modify from 'ol/interaction/Modify'
import Collection from 'ol/Collection'


const initVector = (mapView, overlay, getLayer) => {
  /**
   * set the marker ID to 0
   */

  let MarkId = 0

  /**
   * marker source
   */

  const Msource = new VectorSource()
  /**
   * marker variable for the symbols
   */

  const myColors = ['rgba(255,255,255,0.1)']
//  const mySource = ['/img/symbols/marker5.png', '/img/symbols/marker2.png', '/img/symbols/marker3.png', '/img/symbols/marker4.png', '/img/symbols/marker1.png']
const mySource = ['/img/symbols/marker100.png']
  /**
   * add the correct symbols and prevent duplicates
   */

  let iterator = 0

  const styleFn = (symbol) => {
    let retSytle

    /**
     * get the current style if is already setup
     */

    if (typeof (symbol.get('styledwithcolor')) !== 'undefined') {
      retSytle = new Style({
        image: new Icon({
          // opacity: 0.95,
          src: symbol.get('mysource'),
          color: symbol.get('styledwithcolor'),
          anchor: [14, 40],
          anchorXUnits: 'pixels',
          anchorYUnits: 'pixels'
        })
      })
    }
    /**
     * else set the new style
     */
    else {
      symbol.set('styledwithcolor', myColors[iterator])
      symbol.set('mysource', mySource[iterator])

      retSytle = new Style({
        image: new Icon({
          src: mySource[iterator],
          color: myColors[iterator],
          anchor: [14, 40],
          anchorXUnits: 'pixels',
          anchorYUnits: 'pixels'
        })
      })
      /**
       * removing the last symbols prevent to add duplicates
       */

      mySource.shift()
    }
    return [retSytle]
  }

  /**
   * marker layer
   * set the z-index of the layer to 6 to be sure that is on top of all the others one
   */

  const markLayer = new VectorLayer({
    source: Msource,
    style: styleFn
  })

  markLayer.setZIndex(6)

  /**
   * add the markLayer layer to the map
   */

  mapView.addLayer(markLayer)

  /**
   * marker tool handler
   */

  $('#Marker').click(function (e) {
    /**
     * prevent default behaviour
     * add the mark interaction to the map
     * hide the popup
     */

    e.preventDefault()

    addMark('Point')

    overlay.setPosition(undefined)
  })

  /**
   * these var are for the creation of the marker
   * they are global so we can remove it later
   */

  let mark
  let counter = true

  /**
   * add the marker
   */

  const addMark = (Type) => {
    /**
     * set counter to true
     * we use it to prevent error when we remove a marker
     */

    counter = true

    /**
     * set the mark interaction
     */

    mark = new Draw({
      source: Msource,
      type: Type
    })

    /**
     * limit the number of markers to 4
     */

    if (Msource.getFeatures().length < 1) {
      /**
       * add the custbtnsel class to the marker button
       * disable the buttons to prevent multiple instances
       */

      $('#Marker').addClass('custbtnsel')
      $('#Marker').prop('disabled', true)
      $('#markdrag').prop('disabled', true)
      $('#markdel').prop('disabled', true)

      /**
       * add the mark interaction to the map
       */

      mapView.addInteraction(mark)

      /**
       * this occurs when you finish to draw the marker
       */

      mark.on('drawend', () => {
        counter = true

        /**
         * we increase the marker ID plus 1
         */

        MarkId += 1
      })

      /**
       * this occurs after you finish to draw the marker
       */

      markLayer.on('change', () => {
        mapView.removeInteraction(mark)

        /**
         * remove the custbtnsel class
         * enable the buttons
         */

        setTimeout(() => {
          $('#Marker').removeClass('custbtnsel')
          $('#Marker').prop('disabled', false)
          $('#markdrag').prop('disabled', false)
          $('#markdel').prop('disabled', false)
        }, 300)

        /**
         * we check if we are adding or removing markers
         */

        if (counter === true) {
          /**
           * we set immediately the counter to false and stop to run this function after it finish
           * apply the correct id to the last plotted marker
           */

          counter = false
          let ind = Msource.getFeatures().length - 1
          Msource.getFeatures()[ind].setId(MarkId - 1)

          /**
           * get the marker's coordinates
           * get the current date
           */

          let markerCoords = Msource.getFeatures()[0].getGeometry().getCoordinates()

          /**
           * get the url
           * populate the suspid and expdate from the url params
           */

          let urlparams = window.location.search.replace('?', '')
          let allparams = urlparams.split('&')

          let suspid = ''
          let expdate = ''

          if (allparams[1].search('suspid') > -1) {
            suspid = allparams[1].replace('suspid=', '')
          }

          if (allparams[2].search('expdate') > -1) {
            expdate = allparams[2].replace('expdate=', '')
          }

          /**
           * create the json data
           */

          let theData = '{"suspid": "' + suspid + '", "coords": "' + markerCoords + '", "expdate": "' + expdate + '"}'

          /**
           * send an ajax reuqest
           */
          $('.loading').show()
          $.ajax({
            url: '/traffweb/psa-add',
            type:"POST",
            data: {
              jdata: theData
            }
          }).done(function (data) {
            console.log(data)
          }).fail(function (jqXHR, textStatus) {
            console.log('Error: ' + textStatus)
          })
          .always(() => {
            /**
             * hide the loading bar
             */

            $('.loading').hide()
          })
        }

        /**
         * end markLayer.on('change', () => {
         */
      })
      /**
       * end if (Msource.getFeatures().length < 1)
       */
    }

    /**
     * if the Msource.getFeatures().length is > 1
     */

    else {
      /**
       * remove the mark interaction
       * remove the custbtnsel class from the button
       */

      mapView.removeInteraction(mark)
      $('#Marker').removeClass('custbtnsel')
    }

    /**
     * end function addMark (Type)
     */
  }

  /**
   * drag button handler
   */

  $('#markdrag').on('click', function (e) {
    /**
     * prevent default behaviour
     * hide the popup
     * remove the mark interaction in case is active
     */

    e.preventDefault()

    overlay.setPosition(undefined)

    mapView.removeInteraction(mark)

    /**
     * prevent error enabling the click just if the marker was already plotted
     */

    if (Msource.getFeatures().length === 1) {
      /**
       * set counter to false to prevent to execute the other function
       */

      counter = false

      /**
       * disable the buttons to prevent multiple instances
       * add the class custbtnsel to the drag button
       */

      $('#Marker').prop('disabled', true)
      $('#markdrag').addClass('custbtnsel')
      $('#markdel').prop('disabled', true)

      /**
       * create the drag interaction
       * add it to the map
       */

      let dragInteraction = new Modify({
        features: new Collection([Msource.getFeatures()[0]]),
        style: null
      })

      mapView.addInteraction(dragInteraction)

      /**
       * pointermove event listen
       */

      mapView.on('pointermove', function (evt) {
        /**
         * if you are moving the map return
         */

        if (evt.dragging) {
          return
        }

        /**
         * change the pointer style to match the marker layer
         */

        let pixel = mapView.getEventPixel(evt.originalEvent)
        let hit = mapView.forEachLayerAtPixel(pixel, () => {
          return true
        }, null, (layer) => {
          return layer === markLayer
        })
        mapView.getTargetElement().style.cursor = hit ? 'pointer' : ''
      })

      /**
       * modifyend event listener
       */

      dragInteraction.on('modifyend', () => {
        /**
         * remove the interaction when the customer finish to drag the marker
         */
        mapView.removeInteraction(dragInteraction)

        /**
         * enable the buttons
         * remove the class custbtnsel from the button
         */

        setTimeout(function () {
          $('#Marker').prop('disabled', false)
          $('#markdrag').removeClass('custbtnsel')
          $('#markdel').prop('disabled', false)
        }, 300)

        /**
         * get the marker's coordinates
         */

        let markerCoords = Msource.getFeatures()[0].getGeometry().getCoordinates()

        /**
         * get the url
         * populate the suspid from the url params
         */

        let urlparams = window.location.search.replace('?', '')
        let allparams = urlparams.split('&')

        let suspid = ''

        if (allparams[1].search('suspid') > -1) {
          suspid = allparams[1].replace('suspid=', '')
        }

        /**
         * create the json data
         */

        let theData = '{"suspid": "' + suspid + '", "coords": "' + markerCoords + '"}'

        /**
         * send an ajax reuqest
         */
        $('.loading').show()
        $.ajax({
          url: '/traffweb/psa-update',
          type:"POST",
          data: {
            jdata: theData
          }
        }).done(function (data) {
          console.log(data)
        }).fail(function (response) {
          let  error = response.responseJSON.error
          let  textStatus = response.status
          let err = `${textStatus}, ${error}`
          console.log('Error: ' + err)
        })
        .always(() => {
          /**
           * hide the loading bar
           */

          $('.loading').hide()
        })
        /**
         * pointermove event listen
         */

        mapView.on('pointermove', function (evt) {
          /**
           * if you are moving the map return
           */

          if (evt.dragging) {
            return
          }

          /**
           * change the pointer style to match the marker layer
           */

          let pixel = mapView.getEventPixel(evt.originalEvent)
          let hit = mapView.forEachLayerAtPixel(pixel, () => {
            return true
          }, null, (layer) => {
            return layer === getLayer
          })
          mapView.getTargetElement().style.cursor = hit ? 'pointer' : ''
        })

        /**
         * end dragInteraction.on('modifyend', () =>
         * end if ($('#tlfeature').val() !== null)
         * end $('#markdrag').on('click', function (e) {
         */
      })
    }
  })

  /**
   * marker delete button
   */

  $('#markdel').on('click', function (e) {
    /**
     * prevent default behaviour
     * hide the popup
     * set counter to false
     */

    e.preventDefault()

    overlay.setPosition(undefined)

    counter = false

    /**
     * prevent error enabling the click just if the marker was already plotted
     */

    if (Msource.getFeatures().length === 1) {
      /**
       * add the last symbols to the main symbols array
       */

      mySource.unshift(Msource.getFeatures()[0].getProperties().mysource)

      /**
       * remove the marker connected to that ID
       */

      Msource.removeFeature(Msource.getFeatures()[0])

      /**
       * get the url
       * populate the suspid from the url params
       */

      let urlparams = window.location.search.replace('?', '')
      let allparams = urlparams.split('&')

      let suspid = ''

      if (allparams[1].search('suspid') > -1) {
        suspid = allparams[1].replace('suspid=', '')
      }


      let theData = '{"suspid": "' + suspid + '"}'

      /**
       * send the post request
       */
       $('.loading').show()
      $.ajax({
        url: '/traffweb/psa-delete',
        type:"POST",
        data: {
          jdata: theData
        },
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
        }
      }).done(function (data) {
        console.log(data)
      }).fail(function (jqXHR, textStatus) {
        console.log('Error: ' + textStatus)
      })
      .always(() => {
        /**
         * hide the loading bar
         */

        $('.loading').hide()
      })
    /**
     * end if (Msource.getFeatures().length === 1) {
     * end $('#markdel').on('click', function (e) {
     */
    }
  })

/**
 * end const initVector = (mapView, overlay, getLayer, fixed) => {
 */
}

/**
 * EXPORT
 */

export default {
  initVector
}
